import { WATCHLIST_WEBSOCKET_CONNECT_REQUEST, WATCHLIST_WEBSOCKET_CONNECTED, WATCHLIST_WEBSOCKET_CONNECT_ERR, WATCHLIST_WEBSOCKET_DISCONNECT_REQUEST, WATCHLIST_WEBSOCKET_DISCONNECTED, WATCHLIST_WEBSOCKET_DISCONNECT_ERR, WATCHLIST_WEBSOCKET_STATUS_REQUEST, WATCHLIST_WEBSOCKET_STATUS_COMPLETE, WATCHLIST_WEBSOCKET_STATUS_ERR, WEBINAR_ID_SET } from '../actions/actionTypes';
import initialState from "./initialState";
import stateConfig from '../config/state';

function watchlistWebSocketReducer(state = initialState.watchlistWebSocket, action) {
  let status = stateConfig.responseStatus;

  switch (action.type) {
    case WATCHLIST_WEBSOCKET_CONNECT_REQUEST:
      return { ...state, responseStatus: status.DEFAULT, responseErr: null };
    case WATCHLIST_WEBSOCKET_CONNECTED:
      return { ...state, responseStatus: status.COMPLETE, responseErr: null, isConnected: true };
    case WATCHLIST_WEBSOCKET_CONNECT_ERR:
      return { ...state, responseStatus: status.ERROR, responseErr: action.error };
    case WATCHLIST_WEBSOCKET_DISCONNECT_REQUEST:
      return { ...state, responseStatus: status.DEFAULT, responseErr: null };
    case WATCHLIST_WEBSOCKET_DISCONNECTED:
      return { ...state, responseStatus: status.COMPLETE, responseErr: null, isConnected: false };
    case WATCHLIST_WEBSOCKET_DISCONNECT_ERR:
      return { ...state, responseStatus: status.ERROR, responseErr: action.error };
    case WATCHLIST_WEBSOCKET_STATUS_REQUEST:
      return { ...state, responseStatus: status.DEFAULT, responseErr: null, };
    case WATCHLIST_WEBSOCKET_STATUS_COMPLETE:
      return { 
        ...state,
        responseStatus: status.COMPLETE,
        isConnected: action.isConnected,
        isReconnecting: action.isReconnecting,
        webinarId: action.webinarId || state.webinarId
      };
    case WATCHLIST_WEBSOCKET_STATUS_ERR:
      return { ...state, responseStatus: status.ERROR, responseErr: action.error };
    case WEBINAR_ID_SET:
      return { ...state, webinarId: action.webinarId };
    default:
      return state;
  }
}

export default watchlistWebSocketReducer;